/**
 * @description: 请求结果集
 */
export enum ResultEnum {
  SUCCESS = 0,
  ERROR = -1,
  TIMEOUT = 10042,
  TYPE = "success",
}

/**
 * @description: 请求方法
 */
export enum RequestEnum {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  PUT = "PUT",
  DELETE = "DELETE",
}

/**
 * @description:  常用的contentTyp类型
 */
export enum ContentTypeEnum {
  // json
  JSON = "application/json;charset=UTF-8",
  // json
  TEXT = "text/plain;charset=UTF-8",
  // form-data 一般配合qs
  FORM_URLENCODED = "application/x-www-form-urlencoded;charset=UTF-8",
  // form-data  上传
  FORM_DATA = "multipart/form-data;charset=UTF-8",
}

export enum HTTP_STATUS {
  OK = 10000,
  TOKEN_TIMEOUT = 821010108, // 业务层没有连接网关的服务token过期处理
  FILE_EMPTY = 40003, // 文件不存在(回收站彻底删除或不存在)
  FOLDER_DELETE = 40004, // 文件已删除（在回收站中）
  FOLDER_UNAUTHORIZED = 40006,
  WS_UNAUTHORIZED = 84107002,
  DATA_UNAUTHORIZED = 84107003,
  APP_UNAUTHORIZED = 84107004,
  WORKFLOW_UNAUTHORIZED = 84107015,
  UNAUTHORIZED = 401, // 网关层拦截token
  FORBIDDEN = 403,
  NOTFOUND = 404,
  CAPACITY_DEPLETION = 70002, // 容量耗尽
  PROJECT_NOT_IN_ORG = 70005, // 组织和项目不匹配
  NO_PHONE_NUMBER = 84107008, // 没设置手机号
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
  SERVICE_RUN_UNAVAILABLE = 502,
  TOKEN_ACTIVE_FAILED = 40010, // token已过期
  HAS_NOAUTH_DATA = 40015, // 当前操作有部分数据权限不足
  TOKEN_ACTIVED = 40016, // 当前token已激活

  FREQUENT_OPERATIONS = 40011, // 操作频繁
  /**
   * 301 永久重定向
   */
  REDIRECT = 301,
  /**
   * 302 临时重定向
   */
  REDIRECT_TEMPORARY = 302,
  ORG_KB_INVALID = 50005, // 组织知识库不存在
  IP_PERMISSION = 84107011, // ip权限 登出
  IP_LIMIT_DATA = 84107012, // 跳兜底页
  IP_LIMIT_OPERATE = 84107013, // 切组织被拦截

  LOGIN_CHECK_FAIL = 40008, // 用户token验证失败

  VERIFICATION_TOKEN_INVALID = 41009, // 验证码登录token过期
}
